import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 50,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block'
  }
}));

const NotFound = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        justify="center"
        spacing={4}
      >
        <Grid
          item
          lg={8}
          xs={12}
        >
          <div className={classes.content}>
            <Typography variant="h1">
              404: La página que esta buscando no esta disponible
            </Typography>
            <Typography variant="subtitle2">
              Favor acceder a las opciones del sitio mediante las opciones de navegación
            </Typography>
            <img
              alt="Página no disponible"
              className={classes.image}
              src="/images/404-not-found.png"
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotFound;
